module.exports = __webpack_public_path__ + "img/tuceng19.040c96f4.png";